export class ScrollTop {

  constructor() {
    this._onScroll = this._onScroll.bind(this);

    this._container = document.createElement('div');
    this._container.classList.add('scrollTop');

    document.body.append(this.elem);

    window.addEventListener('scroll', this._onScroll);
    this.elem.addEventListener('click', this._onClick);

  }


  _onScroll() {

    const s = window.pageYOffset;
    const h = window.innerHeight;

    if (s > h) {
      this.elem.classList.add('active');
    } else {
      this.elem.classList.remove('active');
    }
  }


  _onClick() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }


  get elem() {
    return this._container;
  }
}

const scropllTop = new ScrollTop();